import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("matiqs_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && localStorage.getItem("matiqs_token")) {
      const detail = err.response?.data?.detail;
      const ended = typeof detail === "string" && detail.includes("two-device limit");
      localStorage.removeItem("matiqs_token");
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = ended ? "/login?reason=session" : "/login";
      }
    }
    return Promise.reject(err);
  }
);

export async function openDownload(path) {
  // Open the tab synchronously (within the click gesture) to dodge popup blockers,
  // then point it at the file once we have a short-lived, download-scoped token.
  const win = window.open("", "_blank");
  try {
    const { data } = await api.post("/auth/download-token");
    const sep = path.includes("?") ? "&" : "?";
    const url = `${API}${path}${sep}token=${data.token}`;
    if (win) win.location = url;
    else window.open(url, "_blank");
  } catch (e) {
    if (win) win.close();
    throw e;
  }
}

export function apiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
